import React, {memo, useContext, useRef} from 'react';
import { BarChart, Bar, XAxis, YAxis, LabelList, CartesianGrid } from 'recharts';
import Grid from '@material-ui/core/Grid';
import {orderBy} from 'lodash'
import {calculateDataTotal, calculatePercent, currencyFormatter} from "./chartFunctions";
import useComponentSize from "@rehooks/component-size";
import {CurrencyContext} from "../../hooks/useCurrency";
import {normalizeProjectName} from "./chartFunctions";
import {makeStyles} from "@material-ui/styles";

const useStyles = makeStyles(theme => ({
  '@global': {
    '.recharts-text.recharts-label': {
      fill: '#000000'
    }
  },
}));

const Chart = ({data, colorsForNames}) => {
  const ref = useRef(null);
  const {width} = useComponentSize(ref);
  const sortedData = orderBy(data, ['value'], ['desc']);

  useStyles();

  const {symbol} = useContext(CurrencyContext);

  const dataTotal = calculateDataTotal(data);

  const dataWithColors = sortedData.map((item, i) => {
    const percent = calculatePercent(dataTotal, item.value);
    return {
      ...item,
      fill: colorsForNames[item.name],
      normalizedName: normalizeProjectName(item.name),
      percent,
      labelValue: currencyFormatter(item.value, symbol),
      labelPercent: percent.toFixed(1) + "%"
    };
  });

  const height = Math.max(400, dataWithColors.length * 26);

  const percentFormatter = (value) => `${value} %`;

  return <Grid container justify='flex-end' ref={ref}>
    <Grid item>
      <BarChart width={width} height={height} data={dataWithColors}>
        <CartesianGrid vertical={false}/>
        <XAxis dataKey={"normalizedName"}/>
        <YAxis tickFormatter={percentFormatter}  padding={{ top: 40 }} />
        <Bar dataKey="percent" isAnimationActive={false}>
          <LabelList dataKey={"labelValue"} position="top" offset={20} />
          <LabelList dataKey={"labelPercent"} position="top"  />
        </Bar>
      </BarChart>
    </Grid>
  </Grid>
};

export default memo(Chart);
